import axios from 'axios'
import {
  SearchResponseInterface,
  SearchResultInterface,
} from 'common/types/search-interfaces'

export interface getBlogSearchProps {
  blogPath: string
  query?: string | null
  limit?: string | null
  page?: string | null
}

export const getBlogSearch = async ({
  blogPath = '',
  query,
  limit = '10',
  page = '1',
}: getBlogSearchProps): Promise<
  SearchResponseInterface<SearchResultInterface>
> => {
  const res = await axios.get(`${blogPath}/blog-search`, {
    params: {
      query,
      limit,
      page,
    },
  })
  return res.data
}
